// Auto-generated skeleton for PropertyManager

import { Person } from "./Person";

export const PropertyManager: Api.PropertyManager = {
  id: 0,
  hp_id: null,
  person_id: 0,
  created: null,
  updated: null,
  person: Person,
};

